<template>
  <v-container
    id="usuario-produtor-form"
    fluid
    tag="section"
  >
    <v-row>
      <v-col
        cols="12"
      >
        <validation-observer v-slot="{ invalid }">
          <form @submit.prevent="onSubmit">
            <base-material-card
              color="primary"
              icon="mdi-camera-account"
              :title="$t('edit-profile')"
              :app-online="appOnline"
              class="py-3 px-5"
            >
              <v-skeleton-loader
                v-if="loading"
                type="list-item-two-line, list-item-two-line, list-item-two-line, list-item-two-line, actions"
              />
              <div
                v-else
              >
                <v-row>
                  <v-col
                    cols="12"
                  >
                    <tex-field-with-validation
                      v-model="produtor.nome"
                      rules="required|min:5"
                      label="Nome..."
                      prepend-icon="mdi-face-man-outline"
                    />

                    <tex-field-with-validation
                      v-model="produtor.email"
                      rules="email"
                      label="Email..."
                      prepend-icon="mdi-email-outline"
                    />

                    <tex-field-with-validation
                      v-model="produtor.cpf"
                      v-mask="maskcpf"
                      label="CPF..."
                      prepend-icon="mdi-account-box-outline"
                      disabled
                    />

                    <tex-field-with-validation
                      v-model="produtor.telefone"
                      v-mask="maskphone"
                      rules="required"
                      label="Telefone..."
                      prepend-icon="mdi-phone-outline"
                      disabled
                    />
                  </v-col>
                  <v-col
                    cols="15"
                  >
                    <v-menu
                      ref="menuData"
                      v-model="menuData"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="420px"
                      min-width="420px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-row>
                          <v-col
                            cols="1"
                          >
                            <v-icon>mdi-calendar-check-outline</v-icon>
                          </v-col>
                          <v-col cols="3">
                            <v-select
                              v-model="selectedDay"
                              :items="dayOptions"
                              :success="true"
                              label="Dia"
                              @change="updateDate"
                              v-on="on"
                            />
                          </v-col>
                          <v-col cols="4">
                            <v-select
                              v-model="selectedMonth"
                              :items="monthOptions"
                              :success="true"
                              label="Mês"
                              @change="updateDate"
                              v-on="on"
                            />
                          </v-col>
                          <v-col cols="4">
                            <v-select
                              v-model="year"
                              :items="yearOptions"
                              :success="true"
                              label="Ano"
                              @change="updateDate"
                              v-on="on"
                            />
                          </v-col>
                        </v-row>
                      </template>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col
                    cols="8"
                    lg="3"
                  >
                    <v-btn
                      class="v-btn--block"
                      color="error"
                      default
                      @click="showDialog(3000, 'Tem certeza que deseja remover o cadastro?')"
                    >
                      remover cadastro
                    </v-btn>
                  </v-col>
                  <v-col
                    cols="8"
                    lg="3"
                  >
                    <v-btn
                      class="v-btn--block"
                      :disabled="invalid"
                      color="success"
                      default
                      min-width="180"
                      type="submit"
                    >
                      Salvar
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
            </base-material-card>
          </form>
        </validation-observer>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
    <v-dialog
      v-model="dialog.visible"
      max-width="411"
    >
      <v-card>
        <v-card-title>
          <v-spacer />
          <v-icon
            aria-label="Close"
            @click="dialog.visible = false"
          >
            mdi-close
          </v-icon>
        </v-card-title>
        <v-card-text class="text-center">
          {{ dialog.message }}
        </v-card-text>
        <v-card-text class="pb-3 pt-6 text-center">
          <v-btn
            class="mr-3"
            text
            @click="dialog.visible = false"
          >
            Não
          </v-btn>

          <v-btn
            color="success"
            text
            @click="reset(), dialog.visible = false"
          >
            Sim
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import UsuarioProdutorService from '../../../services/usuarioprodutor'
  import utils from '../../../services/utils'
  import moment from 'moment'

  export default {
    name: 'EditProfileForm',
    components: {
      DashboardCoreSnackbar: () => import('../components/core/Snackbar'),
    },
    mixins: [utils],

    $_veeValidate: {
      validator: 'new',
    },

    data: vm => ({
      selectedDay: '01',
      selectedMonth: '01',
      year: new Date().getFullYear().toString(),
      appOnline: navigator.onLine,
      produtor: {
        id: '',
        chaveativacao: '',
        nome: '',
        email: '',
        cpf: '',
        telefone: '',
        datanascimento: '',
        codigoativacao: '',
      },
      maskphone: '(##)#####-####',
      maskcpf: '###.###.###-##',
      date: '',
      dateFormatted: '',
      menuData: false,
      maskdate: '##/##/####',
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      dialog: {
        visible: false,
        message: '',
      },
      loading: true,
    }),
    computed: {
      dayOptions () {
        const daysInMonth = this.getDaysInMonth(parseInt(this.selectedMonth), this.year)
        return Array.from({ length: daysInMonth }, (_, index) =>
          String(index + 1).padStart(2, '0'),
        )
      },
      monthOptions () {
        return Array.from({ length: 12 }, (_, index) => String(index + 1).padStart(2, '0'))
      },
      yearOptions () {
        const currentYear = new Date().getFullYear()
        return Array.from({ length: 101 }, (_, index) => String(currentYear - index))
      },
    },
    watch: {
      date (val) {
        this.dateFormatted = this.formatDate(val)
        this.produtor.datanascimento = val
      },
      dateFormatted (val) {
        // console.log('dateFormatted')
        var data = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD')
        this.produtor.datanascimento = data
      },
    },

    mounted () {
      // this.verificaVersao()
      this.carregaInfoSistemaOperacional()
      if (localStorage.chaveativacao && localStorage.chaveativacao !== 'undefined') {
        this.chaveativacao = localStorage.chaveativacao
        this.carregaForm()
      } else {
        localStorage.clear()
        this.$router.push('/registrar')
      }
    },

    methods: {
      updateDate () {
        this.menuData = false
        this.data = `${this.selectedDay}/${this.selectedMonth}/${this.year}`
        this.produtor.datanascimento = this.data
      },
      getDaysInMonth (month, year) {
        return new Date(year, month, 0).getDate()
      },
      carregaForm () {
        this.loading = true
        UsuarioProdutorService.show(this.chaveativacao).then(resposta => {
          this.produtor.nome = resposta.data.obj.nome
          this.produtor.email = resposta.data.obj.email
          this.produtor.cpf = resposta.data.obj.cpf
          this.produtor.telefone = resposta.data.obj.telefone
          this.produtor.datanascimento = this.formatDate(new Date(resposta.data.obj.datanascimento).toISOString().substr(0, 10))
          this.dateFormatted = this.produtor.datanascimento
          this.date = this.parseDate(this.produtor.datanascimento)
          this.loading = false
          this.appOnline = true
          this.paseDadosNascimento()
          this.verificaVersao(resposta.data.versao_vue)
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            // Dados do Produtor Offline =========================================v
            this.produtor.nome = localStorage.nome
            this.produtor.cpf = localStorage.cpf
            this.produtor.telefone = localStorage.telefone
            this.produtor.email = localStorage.email
            this.produtor.datanascimento = localStorage.datanascimento
            // Dados do Produtor Offline =========================================^
            this.appOnline = false
          } else if (e.response.data.status === 'remover') {
            localStorage.clear()
            this.$router.push('/registrar')
          } else {
            this.showSnackbar('error', 3000, e.response.data.status + ' - Erro ao carregar informações de produtor')
            this.$router.push('/')
          }
          this.loading = false
        })
      },
      paseDadosNascimento () {
        if (this.produtor.datanascimento) {
          this.selectedDay = moment(this.produtor.datanascimento, 'DD/MM/YYYY').format('DD')
          this.year = moment(this.produtor.datanascimento, 'DD/MM/YYYY').format('YYYY')
          this.selectedMonth = moment(this.produtor.datanascimento, 'DD/MM/YYYY').format('MM')
        }
      },
      onSubmit () {
        this.date = this.produtor.datanascimento
        this.produtor.chaveativacao = localStorage.chaveativacao
        this.produtor.platform = localStorage.platform
        this.produtor.osname = localStorage.osname

        if (localStorage.platform && localStorage.platform !== '') {
          this.produtor.platform = localStorage.platform
        } else {
          this.produtor.platform = 'unknown'
        }
        console.log(this.produtor.platform)
        this.salvar()
      },

      salvar () {
        // console.log('methods.salvar')
        UsuarioProdutorService.atualizar(this.produtor).then(resposta => {
          this.produtor.id = resposta.data.id
          this.produtor.chaveativacao = resposta.data.chaveativacao
          this.cadastrook = true
          // Dados do Produtor =========================================v
          localStorage.nome = this.produtor.nome
          localStorage.cpf = this.produtor.cpf
          localStorage.telefone = this.produtor.telefone
          localStorage.email = this.produtor.email
          localStorage.datanascimento = this.produtor.datanascimento
          // Dados do Produtor =========================================^
          this.codigoativacaotemp = resposta.data.codigoativacao
          this.appOnline = true
          this.showSnackbar('success', 3000, 'Cadastro de Produtor atualizado com sucesso')
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, ' Falha na conexão com a internet')
            this.appOnline = false
          } else {
            this.showSnackbar('error', 3000, 'Falha ao salvar o Cadastro de Produtor')
            this.$router.push('/')
          }
        })
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
      showDialog (timeout, message) {
        this.dialog.visible = true
        this.dialog.timeout = timeout
        this.dialog.message = message
      },

      formatDate (date) {
        // console.log('methods.formatDate')
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      parseDate (date) {
        // console.log('methods.parseDate')
        if (!date) return null

        const [day, month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      reset () {
        UsuarioProdutorService.desativar(localStorage.chaveativacao).then(resposta => {
          localStorage.clear()
          this.$router.push('/registrar')
          this.appOnline = true
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, ' Falha na conexão com a internet')
            this.appOnline = false
          } else {
            this.showSnackbar('error', 3000, e.response.data.errors)
          }
        })
      },
    },
  }
</script>
